import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/** Singleton bridge to the Pyodide/Arelle Web Worker. */
@Injectable({ providedIn: 'root' })
export class XbrlWorkerBridgeService {
  private worker?: Worker;
  private readonly messageSubject = new Subject<unknown>();
  readonly messages$ = this.messageSubject.asObservable();

  readonly supported = typeof Worker !== 'undefined';

  constructor() {
    if (!this.supported) {
      return;
    }
    try {
      this.worker = new Worker(new URL('../xbrl-engine.worker', import.meta.url), {
        type: 'module',
      });
      this.worker.onmessage = (event: MessageEvent) => {
        this.messageSubject.next(event.data);
      };
      this.worker.onerror = () => {
        this.messageSubject.next({ type: 'worker-error' });
      };
    } catch {
      this.worker = undefined;
    }
  }

  post(message: unknown, transfer: Transferable[] = []): void {
    this.worker?.postMessage(message, transfer);
  }
}
